import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/_individual/individual/_profile/my-profile/_layout/')({
  beforeLoad: () => {
    throw redirect({
      to: '/individual/my-profile/education-and-qualification'
    });
  }
});